import { getAPI } from "@/axios-api";

export async function fetchUserSubscription() {
  try {
    const response = await getAPI.get('subscriptions/find-subscription');
    
    if (response.status === 200) {
      return {
        data: response.data?.data,
        remain_days: response.data?.data?.remain_days,
        //expiration_date: new Date(response.data?.data?.created_at).setDate(new Date(response.data?.data?.created_at).getDate() + 30).toISOString()
      };
    }
    return { data: null };
  } catch (error) {
    if (error.response) {
      console.error('API Error:', error.response.data);
    } else if (error.request) {
      console.error('Network Error:', error.request);
    }
    return { error: true };
  }
}